/**
 * 项目进度实体
 */

import { useState, useEffect } from 'react';
import {
    ConfigProvider,
    Modal,
    Row,
    Col,
    message,
    DatePicker,
    Input,
    Select,
    Slider,
    ColorPicker,
} from 'antd';
import $ from 'jquery';
import {
    AddRequestHeaders,
    currentDate,
    presets,
    rff,
} from '../../incs/FunHelper';
import CNF from '../../incs/Config';

/** 
* 日期样式
*/
import locale from 'antd/es/date-picker/locale/zh_CN';
import 'dayjs/locale/zh-cn';
import dayjs from 'dayjs';

const Option = Select.Option;
const { TextArea } = Input;

const Entity = (props) => {
    const [messageApi, contextHolder] = message.useMessage();

    const [loading, setLoading] = useState(false);
    const [open, setOpen] = useState(false);
    const [phase, setPhase] = useState('');
    const [progress, setProgress] = useState(0);
    const [recordTime, setRecordTime] = useState(currentDate);
    const [nodeStatus, setNodeStatus] = useState(CNF.progressLogNodeStatus[1]);
    const [nodeColor, setNodeColor] = useState('#1677ff');
    const [description, setDescription] = useState('');

    const cancel = () => {
        setOpen(false);
        setLoading(false);
        setPhase('');
        setProgress(0);
        setRecordTime(currentDate);
        setNodeColor(CNF.progressLogNodeStatus[1]);
        setNodeColor('#1677ff');
        setDescription('');
    };

    useEffect(() => {
        // 修改初始化
        if (props.record) {
            setPhase(props.record.phase);
            setProgress(props.record.progress);
            setRecordTime(props.record.record_time ? props.record.record_time : currentDate);
            setNodeStatus(props.record.node_status ? props.record.node_status : CNF.progressLogNodeStatus[1]);
            setNodeColor(props.record.node_color ? props.record.node_color : '#1677ff');
            if (props.action === CNF.actionName.UPDATE) {
                setDescription(props.record.description ? props.record.description : '');
            }
        }
    }, [props.record, props.action]);

    useEffect(() => {
        setOpen(props.open);
    }, [props]);


    const ok = () => {
        //  参数校验
        if (recordTime === '') {
            message.error('记录时间不能为空！');
            return;
        }
        if (description === '') {
            message.error('进度说明不能为空！');
            return;
        }

        setLoading(true);

        let data = {
            'phase': phase,
            'progress': progress,
            'record_time': recordTime,
            'node_color': nodeColor,
            'node_status': nodeStatus,
            'description': description,
        }
        if (props.action === CNF.actionName.CREATE) {
            data.action = CNF.actionName.PROGRESS;
        }
        $.ajax({
            url: CNF.api + 'project/' + (props.action === CNF.actionName.CREATE ? 'details' : 'progressLogs') + '/' + props.record.key,
            headers: AddRequestHeaders(),
            type: props.action === CNF.actionName.CREATE ? 'PATCH' : 'PUT',
            dataType: 'JSON',
            data: JSON.stringify(data),
        }).done(function (data) {
            if (data.res === 0) {
                messageApi.success(data.msg, CNF.messageDuration);
                setTimeout(function () {
                    cancel();
                    props.isRefresh();
                }, CNF.messageDuration * 1000);
            } else {
                setLoading(false);
                messageApi.error(data.msg, CNF.messageDuration);
            }
        }).fail(function (data) {
            setLoading(false);
            messageApi.error(data.responseJSON.detail, CNF.messageDuration);
        });
    };



    const marks = {
        0: "0",
        50: "50",
        70: "70",
        80: "80",
        90: "90",
        100: {
            style: {
                color: "#008B00",
            },
            label: <strong>100</strong>,
        },
    };
    return (
        <ConfigProvider
            locale={locale}
            theme={{
                token: {
                    colorPrimary: global.THEMECOLOR,
                },
            }}
        >
            {contextHolder}
            <Modal
                width={550}
                title={props.record ? props.record.name : ''}
                open={open}
                onOk={ok}
                onCancel={cancel}
                keyboard={true}
                okText='确认'
                cancelText='取消'
                okButtonProps={{ disabled: loading }}
            >
                <Row>
                    <Col span={24}>{rff}项目阶段</Col>
                    <Col span={24}>
                        <Select
                            style={{ width: '100%' }}
                            value={phase}
                            onChange={(value) => {
                                setPhase(value);
                                if (value === CNF.projectPhases[4].value) {
                                    setProgress(70);
                                } else if (value === CNF.projectPhases[5].value) {
                                    setProgress(90);
                                }
                            }}
                            disabled={loading}
                        >
                            {
                                CNF.projectPhases.map((item) => {
                                    return <Option key={item.value} value={item.value}>{item.key}</Option>
                                })
                            }
                        </Select>
                    </Col>
                </Row>
                <Row style={{ marginTop: CNF.rowMarginTop }}>
                    <Col span={24}>{rff}项目进度</Col>
                    <Col span={24}>
                        <Slider
                            marks={marks}
                            value={progress}
                            onChange={(value) => setProgress(value)}
                        />
                    </Col>
                </Row>
                <Row>
                    <Col span={11}>{rff}记录时间</Col>
                    <Col span={11} offset={2}>{rff}节点状态</Col>
                </Row>
                <Row>
                    <Col span={11}>
                        <DatePicker
                            placeholder='记录时间'
                            style={{ width: '100%' }}
                            locale={locale}
                            onChange={(_, dateString) => setRecordTime(dateString)}
                            value={dayjs(recordTime, 'YYYY-MM-DD')}
                            disabled={loading}
                        />
                    </Col>
                    <Col span={11} offset={2} >
                        <Select
                            style={{ width: '100%' }}
                            options={CNF.progressLogNodeStatus.map((item) => ({
                                lable: item,
                                value: item,
                            }))}
                            disabled={loading}
                            value={nodeStatus}
                            onChange={(value) => setNodeStatus(value)}
                        />
                    </Col>
                </Row>
                <Row style={{ marginTop: CNF.rowMarginTop, }}>
                    <Col span={24}>{rff}节点颜色</Col>
                    <Col span={24}>
                        <ColorPicker
                            placement='right'
                            presets={presets}
                            onChangeComplete={(value) => setNodeColor(value.toHexString())}
                            value={nodeColor}
                            disabled={loading}
                        />
                    </Col>
                </Row>
                <Row style={{ marginTop: CNF.rowMarginTop, }}>
                    <Col span={24}>{rff}进度说明</Col>
                    <Col span={24}>
                        <TextArea
                            placeholder='进度说明可写在这里....'
                            autoSize={{ minRows: 3, maxRows: 6 }}
                            onChange={(e) => setDescription(e.target.value)}
                            value={description}
                            disabled={loading}
                        />
                    </Col>
                </Row>
            </Modal>
        </ConfigProvider >
    );
}

export default Entity